import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button } from "@air/primitive-button";
import { Modal, ModalCloseButton, ModalTitle } from "@air/primitive-modal";
import pluralize from "pluralize";
import { memo, useCallback, useMemo, useState } from "react";
import { ResizableEditableTextInput } from "~/components/ResizableEditableTextInput";
export const BulkEditPlainTextCustomFieldModal = /*#__PURE__*/ memo((param)=>{
    let { field, assetIds, boardIds, initialValues, onClose, onSave } = param;
    var _initialValues_;
    const allHaveSameValue = useMemo(()=>{
        var _initialValues_;
        const baseValue = (_initialValues_ = initialValues[0]) === null || _initialValues_ === void 0 ? void 0 : _initialValues_.plainTextValue;
        return initialValues.every((cf)=>cf.plainTextValue === baseValue);
    }, [
        initialValues
    ]);
    const originalValue = allHaveSameValue ? ((_initialValues_ = initialValues[0]) === null || _initialValues_ === void 0 ? void 0 : _initialValues_.plainTextValue) || "" : "";
    const [plainTextValue, setPlainTextValue] = useState(originalValue);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [isTouched, setIsTouched] = useState(false);
    const onSubmit = useCallback((newValue)=>{
        if (originalValue === newValue) {
            setIsTouched(false);
        } else {
            setPlainTextValue(newValue);
        }
    }, [
        originalValue
    ]);
    const onConfirm = useCallback(async ()=>{
        setIsSubmitting(true);
        await onSave({
            assetIds,
            boardIds,
            baseCustomField: field,
            nextPlainTextValue: plainTextValue
        });
        onClose();
    }, [
        assetIds,
        boardIds,
        field,
        onClose,
        onSave,
        plainTextValue
    ]);
    return /*#__PURE__*/ _jsx(Modal, {
        isOpen: true,
        onDismiss: onClose,
        children: /*#__PURE__*/ _jsxs("div", {
            className: "flex flex-col gap-6",
            children: [
                /*#__PURE__*/ _jsxs("header", {
                    className: "flex justify-between gap-4",
                    children: [
                        /*#__PURE__*/ _jsxs(ModalTitle, {
                            children: [
                                "Edit ",
                                field.name
                            ]
                        }),
                        /*#__PURE__*/ _jsx(ModalCloseButton, {
                            className: "shrink-0",
                            onClick: onClose
                        })
                    ]
                }),
                /*#__PURE__*/ _jsxs("p", {
                    className: "text-16 text-grey-11",
                    children: [
                        "Enter a value below to apply to the ",
                        pluralize("item", assetIds.length + boardIds.length, true),
                        " you’ve selected."
                    ]
                }),
                /*#__PURE__*/ _jsx(ResizableEditableTextInput, {
                    label: "Field value",
                    placeholder: "None",
                    defaultValue: plainTextValue,
                    onSubmit: onSubmit,
                    appearance: "outline",
                    onChange: ()=>setIsTouched(true)
                }),
                /*#__PURE__*/ _jsxs("footer", {
                    className: "flex justify-end gap-3",
                    children: [
                        /*#__PURE__*/ _jsx(Button, {
                            appearance: "ghost",
                            color: "grey",
                            onClick: onClose,
                            size: "large",
                            children: "Cancel"
                        }),
                        /*#__PURE__*/ _jsx(Button, {
                            "data-testid": "BULK_EDIT_PLAIN_TEXT_CUSTOM_FIELD_MODAL_SAVE",
                            isLoading: isSubmitting,
                            disabled: !isTouched || isSubmitting,
                            appearance: "filled",
                            color: "blue",
                            size: "large",
                            onClick: onConfirm,
                            children: "Save"
                        })
                    ]
                })
            ]
        })
    });
});
BulkEditPlainTextCustomFieldModal.displayName = "BulkEditPlainTextCustomFieldModal";
